<template>
  <select2
    :required="!atLeastSectorSelected"
    :options="options"
    v-model="selected"
    placeholder="Sector"
    parent="sector"
  >
  </select2>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Select2 from "./Select2Wrapper.vue";

export default {
  name: "SectorsDropDown",
  components: {
    select2: Select2
  },
  data: function() {
    return {
      selected: ""
    };
  },
  computed: {
    ...mapGetters(["sectors", "selectedDropdownSector", "fundingNeed"]),
    atLeastSectorSelected() {
      return this.selectedDropdownSector != undefined;
    },
    options: function() {
      var opt = this.sectors.map((sector, i) => {
        return {
          id: sector.code,
          text: sector.name
        };
      });
      return opt;
    }
  },
  methods: {
    ...mapMutations({
      setSector: "setSectorsParam",
      setDropdownSector: "setDropdownSector"
    })
  },
  watch: {
    selected: function(value) {
      if (value != null) {
        var sector = this.sectors.filter(item => item.code == value)[0];
        this.setSector(sector);
      }
      this.setDropdownSector(value);
    }
  },
  mounted() {
    if (this.selectedDropdownSector) {
      this.selected = this.selectedDropdownSector;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/elements/SearchBar/SectorsDropDown.vue